import React from 'react'
import * as terminateProjectOtherType from './terminateProjectType'
import useTerminateProject from './useTerminateProject'

// --- MaterialUI --- //
import { Grid, makeStyles } from '@material-ui/core'

// --- FinalForm --- //
import { Form, FormSpy } from 'react-final-form'
import arrayMutators from 'final-form-arrays'

// --- Control --- //
import Dialog from '../../../../../../control/dialog/dialog'

// --- Share UI --- //
import EthicsForm from '../../../../shareUI/ethicsForm/ethicsForm'
import UploadDoc from '../../../../shareUI/uploadDoc/uploadDoc'
import RemarkFromAdmin from '../../../../shareUI/remarkFromAdmin/remarkFromAdmin'
import useManageProjectStore from '../../../../../../stores/manageProject/useManageProjectStore'
import useSnackbarAction from '../../../../../../stores/snackbar/snackbarAction'

import constSubmittedStatus from '../../../../../../constants/submittedStatus'
import useTranslate from '../../../../../../i18n/useTranslate'
import PageAction from '../../pageAction'
import ResearcherForm from '../../../../shareUI/researcherForm/researchForm'
import constSubmittedStep from '../../../../../../constants/submittedStep'
import useCheckPermission from '../../../../../../utilities/checkPermission'
import UploadAdditionalDoc from '../../../../shareUI/uploadAdditionalDoc/UploadAdditionalDoc'
type ErrorsType = {
    langTH?: string
    langEN?: string
}

//View
const RequestFormView = (props: terminateProjectOtherType.RequestFormView) => {
    const {
        onClickSubmit,
        onClickCancel,
        // onClickClose,
        onRefDialogTwo,
        configDialog,
        handleChangeFaculty,
        selectedIrb,
        // configLoading,
        // isEditAfterReview = false,
        // --- props from outer --- //
        btnClose,
        initialData = {},
        isViewMode = false,
        initialUploadFile = [],
        projectData,
        handleDirtyChange,
        onChangeResearcherType,
        valuesForm,
        formValueRef,
        checkUseUploadEdit,
        isDraftData,
        onClickDeleteProject,
    } = props
    //* STORE *//
    const manageProjectStore = useManageProjectStore()
    const snackbarAction = useSnackbarAction()
    const checkPermission = useCheckPermission()
    const canUpdateDocument = checkPermission.checkCanUpdateDocument(projectData)

    const { documentTopic } = manageProjectStore

    const translate = useTranslate()
    const uploadFileinit = documentTopic?.map(() => {
        return {
            uploadFileObj: {
                fileList: [],
                subTopicPageList: [],
            },
        }
    })

    const isNotCompleteDocument = projectData?.submittedStatusInfo?.value === constSubmittedStatus.incorrectDocument
    const isDisableDoc = isViewMode && (!isNotCompleteDocument || !checkUseUploadEdit())

    return (
        <Form
            onSubmit={onClickSubmit}
            mutators={{
                ...arrayMutators,
            }}
            initialValues={{
                ...initialData,
                uploadFile: initialUploadFile && initialUploadFile.length > 0 ? initialUploadFile : uploadFileinit,
                documentAdditionalInfo: projectData?.documentAdditionalInfo ?? [],
            }}
            keepDirtyOnReinitialize={true}
            validate={(values) => {
                const errors: ErrorsType = {}
                if (!values.langTH && !values.langEN) {
                    errors.langTH = translate.get('MESSAGE.M016')

                    errors.langEN = translate.get('MESSAGE.M016')
                }

                return errors
            }}
        >
            {({ handleSubmit, form, dirty, invalid, errors, values }) => {
                valuesForm.current = values
                if (formValueRef) formValueRef.current = values
                return (
                    <React.Fragment>
                        <Grid container spacing={2}>
                            {projectData?.verifyDocument === false && (
                                <Grid item xs={12}>
                                    <RemarkFromAdmin
                                        isShow={projectData?.verifyDocument === false}
                                        projectData={projectData ?? undefined}
                                    />
                                </Grid>
                            )}

                            <Grid item xs={12}>
                                <EthicsForm
                                    callbackChangeFaculty={handleChangeFaculty}
                                    disabled={isViewMode}
                                    isNotCompleteDocument={isNotCompleteDocument}
                                    isDisableRIB={true} //{isDisableIRB || isViewMode}
                                    isDisablePhase={true} //{isViewMode || isApproveWithComment}
                                    isDisableNumPhase={true} //{isViewMode || isApproveWithComment}
                                    callbackChangeResearcherType={onChangeResearcherType}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <ResearcherForm disabled={true} />
                            </Grid>

                            <Grid item xs={12}>
                                <UploadDoc
                                    documentTitleList={documentTopic}
                                    initialData={initialUploadFile}
                                    selectedIrb={selectedIrb}
                                    isViewMode={isDisableDoc && !canUpdateDocument}
                                    latestDocument={projectData?.latestDocument}
                                    isUseUploadfileEdit={checkUseUploadEdit()}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <UploadAdditionalDoc isViewMode={isDisableDoc && !canUpdateDocument} />
                            </Grid>

                            {!btnClose || canUpdateDocument ? (
                                <Grid item xs={12}>
                                    <PageAction
                                        onClickDeleteProject={
                                            isDraftData
                                                ? () => {
                                                      onClickDeleteProject()
                                                  }
                                                : undefined
                                        }
                                        onClickClose={() => {
                                            onClickCancel(dirty)
                                        }}
                                        onClickSave={() => {
                                            form.change('submitType', 'save')
                                            handleSubmit()
                                            invalid &&
                                                errors &&
                                                snackbarAction.openSnackbar({
                                                    message: translate.get('MESSAGE.M012'),
                                                    type: 'error',
                                                })
                                        }}
                                        onClickSaveDraft={() => {
                                            form.change('submitType', 'draft')
                                            handleSubmit()
                                        }}
                                    />
                                </Grid>
                            ) : null}
                        </Grid>

                        <Dialog onRef={onRefDialogTwo} {...configDialog} />
                        <FormSpy subscription={{ dirty: true }} onChange={handleDirtyChange} />
                    </React.Fragment>
                )
            }}
        </Form>
    )
}

//Controller
const RequestFormCtrl = (props: terminateProjectOtherType.RequestFormType) => {
    const requestFormModel = useTerminateProject(props)
    return <RequestFormView {...requestFormModel} {...props} />
}
export default RequestFormCtrl
